import { render, staticRenderFns } from "./EmployeeComparison.vue?vue&type=template&id=5f6bbd4e&"
import script from "./EmployeeComparison.vue?vue&type=script&lang=js&"
export * from "./EmployeeComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports